import type { Option } from '@comparit/core';
import { Dacheindeckung } from '../../../interfaces';

export const dacheindeckungOptions: Option<Dacheindeckung>[] = [
  { label: 'Harte Bedachung', value: Dacheindeckung.HarteBedachung },
  { label: 'Weiche Bedachung', value: Dacheindeckung.WeicheBedachung },
];
